export default __webpack_public_path__ + "static/media/Hats03.6c6e4ea3.png";